module.exports = __webpack_public_path__ + "static/media/certificadosemillero.0409d968.png";